import type { ApiError, ErrorCode } from "@codvero/shared";

export class ApiFailure extends Error {
  constructor(
    public readonly code: ErrorCode | "network",
    public readonly status: number,
    message?: string,
    public readonly details?: unknown,
  ) {
    super(message ?? code);
  }
}

export async function api<T>(path: string, init: RequestInit & { json?: unknown } = {}): Promise<T> {
  const { json, headers, ...rest } = init;
  const h = new Headers(headers);
  if (json !== undefined) h.set("content-type", "application/json");
  const req: RequestInit = { credentials: "same-origin", ...rest, headers: h };
  if (json !== undefined) req.body = JSON.stringify(json);
  let res: Response;
  try {
    res = await fetch(path, req);
  } catch {
    throw new ApiFailure("network", 0);
  }
  if (res.status === 204) return undefined as T;
  const text = await res.text();
  const body = text ? (JSON.parse(text) as unknown) : null;
  if (!res.ok) {
    const err = (body ?? {}) as Partial<ApiError>;
    throw new ApiFailure(err.error ?? "internal", res.status, err.message, err.details);
  }
  return body as T;
}

export const get = <T>(path: string) => api<T>(path);
export const post = <T>(path: string, json?: unknown) => api<T>(path, { method: "POST", json });
export const del = <T = void>(path: string) => api<T>(path, { method: "DELETE" });
